import { retrieveStudioId, retrieveToken } from "../storage";

export const headersBase = () => ({
    Authorization: `Bearer ${retrieveToken()}`,
    'X-SelectedAdminStudio': `${retrieveStudioId()}`
});

export const headersType = () => ({
    "Content-Type": "application/json",
    Authorization: `Bearer ${retrieveToken()}`,
    'X-SelectedAdminStudio': `${retrieveStudioId()}`
})

export const headersParams = (token) => {
    let header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token || retrieveToken()}`,
        'X-SelectedAdminStudio': `${retrieveStudioId()}`
    }
    return header
}

export const headersParamsStuId = (token, studioId) => {
    let header = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token || retrieveToken()}`,
        'X-SelectedAdminStudio': studioId
    }
    return header
}

export const headersExternal = (external) => {
    if (external) {
        return { 'X-SelectedAdminStudio': `${retrieveStudioId()}` };
    } else {
        return {
            Authorization: `Bearer ${retrieveToken()}`,
            'X-SelectedAdminStudio': `${retrieveStudioId()}`
        };
    }
};

export const headersNoBearer = () => ({
    'X-SelectedAdminStudio': `${retrieveStudioId()}`
});

export const headersNoStudio = () => ({
    "Content-Type": "application/json",
});